var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearchBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7,28.7c-7.9,0-14.4-6.4-14.4-14.4C0.4,6.4,6.8,0,14.7,0s14.4,6.4,14.4,14.4C29.1,22.3,22.6,28.7,14.7,28.7z M14.7,2.2 C8,2.2,2.5,7.6,2.5,14.4c0,6.7,5.5,12.2,12.2,12.2s12.2-5.5,12.2-12.2C26.9,7.6,21.4,2.2,14.7,2.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.7,32c-0.3,0-0.6-0.1-0.8-0.3l-6.8-6.9c-0.4-0.4-0.4-1.1,0-1.5s1.1-0.4,1.5,0l6.8,6.9c0.4,0.4,0.4,1.1,0,1.5 C31.3,31.9,31,32,30.7,32z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlack);
export default __webpack_public_path__ + "static/media/icon_search_black.1298dce5316b7d550d71cf69a89af444.svg";
export { ForwardRef as ReactComponent };